export const CompensationRestrictionReason = {
    None: 0,
    IsAoRestricted: 1,
    IsTransactionService: 2
}